import { bandeauBeneficesMock, storeLocatorMock, texteSeoMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [bandeauBeneficesMock, storeLocatorMock(true), texteSeoMock()];

export const tunnelStep1Mock: SlugPage = {
  ...pageBase({
    title: 'Tunnel RDV - Etape 1',
    type: 'tunnel',
    language: 'fr-FR',
    headerId: 'tunnel-fr',
    footerId: '',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
